class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    this.hoverTimeout = null;
    
    // Check if device supports hover (desktop)
    this.supportsHover = window.matchMedia('(hover: hover)').matches;
    
    if (this.supportsHover) {
      this.setupHoverEvents();
    }
  }

  setupHoverEvents() {
    // Prevent default click behavior on summary
    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
    });

    // Open menu on mouseenter
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      this.openMenu();
    });

    // Close menu on mouseleave with a small delay to allow moving to content
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      this.closeMenuDelayed();
    });

    // Keep menu open when hovering over content
    if (this.content) {
      this.content.addEventListener('mouseenter', () => {
        this.cancelClose();
      });

      this.content.addEventListener('mouseleave', () => {
        this.closeMenuDelayed();
      });
    }

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.mainDetailsToggle.contains(e.target)) {
        this.close();
      }
    });
  }

  openMenu() {
    this.cancelClose();
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }
  }

  closeMenuDelayed() {
    this.cancelClose();
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 150); // Small delay to allow moving mouse to content
  }

  cancelClose() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }

  onToggle() {
    // Call parent's onToggle to handle animations
    super.onToggle();
    
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
